unit View.Sincronizacao_Service.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, System.StrUtils, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, UWeb.Enum;

type
  TFViewSincronizacao_ServiceList = class(TForm)
    btNew: TButton;
    Sincronizacao_ServiceDataset: TXDataWebDataSet;
    Sincronizacao_ServiceDatasetid: TIntegerField;
    Sincronizacao_ServiceDatasettabela: TStringField;
    Sincronizacao_ServiceDatasetrota: TStringField;
    Sincronizacao_ServiceDatasetprioridade_sincronizacao: TIntegerField;
    Sincronizacao_ServiceDatasetexcluido: TBooleanField;
    Sincronizacao_ServiceDatasetinclusao: TDateTimeField;
    Sincronizacao_ServiceDatasetalteracao: TDateTimeField;
    Sincronizacao_ServiceDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
    procedure Sincronizacao_ServiceDatasetrotaGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewSincronizacao_ServiceList: TFViewSincronizacao_ServiceList;

implementation

uses
  ConnectionModule, UConstantes;

{$R *.dfm}

{ TFViewSincronizacao_ServiceList }

procedure TFViewSincronizacao_ServiceList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewSincronizacao_ServiceList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSincronizacao_ServiceList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewSincronizacao_ServiceList, AElementID, Result, @AfterCreate);
end;

procedure TFViewSincronizacao_ServiceList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewSincronizacao_ServiceList.edSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewSincronizacao_ServiceList.Sincronizacao_ServiceDatasetrotaGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewSincronizacao_ServiceList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewSincronizacao_ServiceList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewSincronizacao_ServiceList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Sincronizacao_ServiceDataset.Connection.Model.DefaultSchema.FindEntityType(Sincronizacao_ServiceDataset.EntitySetName),
      Sincronizacao_ServiceDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_sincronizacao');
  end;
end;

procedure TFViewSincronizacao_ServiceList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['tabela', 'rota']) of
      0, 1: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewSincronizacao_ServiceList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewSincronizacao_ServiceList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('sincronizacao_service', 'active');
  TUtils.SetValorDicionarioClasses('sincronizacao_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_sincronizacao', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Sincronizacao_ServiceDataset,
    lcPaginator, lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewSincronizacao_ServiceList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(Sincronizacao_ServiceDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewSincronizacao_ServiceList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.sincronizacao_service.list.pagination.info');
  btNew := TButton.Create('view.sincronizacao_service.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.sincronizacao_service.list.table');
  cbPageSize := TComboBox.Create('view.sincronizacao_service.list.cbPageSize');
  edSearch := TEdit.Create('view.sincronizacao_service.list.search');
  lcPaginator := TListControl.Create('view.sincronizacao_service.list.pagination');
  Sincronizacao_ServiceDataset := TXDataWebDataSet.Create(Self);
  Sincronizacao_ServiceDatasetid := TIntegerField.Create(Self);
  Sincronizacao_ServiceDatasettabela := TStringField.Create(Self);
  Sincronizacao_ServiceDatasetrota := TStringField.Create(Self);
  Sincronizacao_ServiceDatasetprioridade_sincronizacao := TIntegerField.Create(Self);
  Sincronizacao_ServiceDatasetexcluido := TBooleanField.Create(Self);
  Sincronizacao_ServiceDatasetinclusao := TDateTimeField.Create(Self);
  Sincronizacao_ServiceDatasetalteracao := TDateTimeField.Create(Self);
  Sincronizacao_ServiceDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Sincronizacao_ServiceDataset.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetid.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasettabela.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetrota.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetprioridade_sincronizacao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetexcluido.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetinclusao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetalteracao.BeforeLoadDFMValues;
  Sincronizacao_ServiceDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewSincronizacao_ServiceList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'Novo';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tabela';
      Title := 'Tabela Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'rota';
      Title := 'Tabela Servidor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prioridade_sincronizacao';
      Title := 'Prioridade Sinc.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Sincronizacao_ServiceDataset.SetParentComponent(Self);
    Sincronizacao_ServiceDataset.Name := 'Sincronizacao_ServiceDataset';
    Sincronizacao_ServiceDataset.EntitySetName := 'Sincronizacao_Service';
    Sincronizacao_ServiceDataset.Connection := DMConnection.ApiConnection;
    Sincronizacao_ServiceDataset.Left := 72;
    Sincronizacao_ServiceDataset.Top := 144;
    Sincronizacao_ServiceDatasetid.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetid.Name := 'Sincronizacao_ServiceDatasetid';
    Sincronizacao_ServiceDatasetid.FieldName := 'id';
    Sincronizacao_ServiceDatasetid.Required := True;
    Sincronizacao_ServiceDatasettabela.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasettabela.Name := 'Sincronizacao_ServiceDatasettabela';
    Sincronizacao_ServiceDatasettabela.FieldName := 'tabela';
    Sincronizacao_ServiceDatasettabela.Required := True;
    Sincronizacao_ServiceDatasettabela.Size := 255;
    Sincronizacao_ServiceDatasetrota.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetrota.Name := 'Sincronizacao_ServiceDatasetrota';
    Sincronizacao_ServiceDatasetrota.FieldName := 'rota';
    Sincronizacao_ServiceDatasetrota.Required := True;
    SetEvent(Sincronizacao_ServiceDatasetrota, Self, 'OnGetText', 'Sincronizacao_ServiceDatasetrotaGetText');
    Sincronizacao_ServiceDatasetrota.Size := 255;
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.Name := 'Sincronizacao_ServiceDatasetprioridade_sincronizacao';
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.FieldName := 'prioridade_sincronizacao';
    Sincronizacao_ServiceDatasetexcluido.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetexcluido.Name := 'Sincronizacao_ServiceDatasetexcluido';
    Sincronizacao_ServiceDatasetexcluido.FieldName := 'excluido';
    Sincronizacao_ServiceDatasetinclusao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetinclusao.Name := 'Sincronizacao_ServiceDatasetinclusao';
    Sincronizacao_ServiceDatasetinclusao.FieldName := 'inclusao';
    Sincronizacao_ServiceDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_ServiceDatasetalteracao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetalteracao.Name := 'Sincronizacao_ServiceDatasetalteracao';
    Sincronizacao_ServiceDatasetalteracao.FieldName := 'alteracao';
    Sincronizacao_ServiceDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Sincronizacao_ServiceDatasetexclusao.SetParentComponent(Sincronizacao_ServiceDataset);
    Sincronizacao_ServiceDatasetexclusao.Name := 'Sincronizacao_ServiceDatasetexclusao';
    Sincronizacao_ServiceDatasetexclusao.FieldName := 'exclusao';
    Sincronizacao_ServiceDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Sincronizacao_ServiceDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 328;
    tmrConsulta.Top := 136;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Sincronizacao_ServiceDataset.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetid.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasettabela.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetrota.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetprioridade_sincronizacao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetexcluido.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetinclusao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetalteracao.AfterLoadDFMValues;
    Sincronizacao_ServiceDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
